// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__hyZav","label":"Completed_label__1Qm14"};